// extracted by mini-css-extract-plugin
export default {"chat":"Chatbot_chat__heO6m","chat__title":"Chatbot_chat__title__mVdZj","chat-input__container":"Chatbot_chat-input__container__MlKbG"};